import React, { useMemo } from 'react';
import { EuiButtonIcon, EuiFlexItem } from '@elastic/eui';
import { FacturasAdapter } from '../../../../../../infraestructure/persistence/rest/FacturasAdapter';
import { useNotifications } from '../../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { CreateHistoricoPDF } from '../Pdf/historico';
import { useLanguage } from '../../../../../../shared/hooks/Language';
//import { useProfile } from '../../../../../../shared/hooks/Profile';

export const DescargaCellRenderer = (params:any,dataFilter:any) =>{

	const {translate} = useLanguage();
    const api:any = new FacturasAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();

	//const {agrupacion, rolPermiso} = dataFilter;
	const {value,data} = params;
	let result: any;

	const RolPermiso = useMemo(()=> data && data.rolPermiso,[data])

	const onClick = ()=>{
		GetHistoricoFacturacionExpatriados(params.value, RolPermiso)
	}

	const button = (
        <EuiButtonIcon iconType='download' size='m' onClick={()=>onClick()}/>
    );

    const GetHistoricoFacturacionExpatriados = async (idFactura:string,rolPermiso:string) => {
		const request = {idFactura:idFactura, rolPermiso:rolPermiso, esFacturacion:false}
		try {
			result = await api.GetHistoricoFacturacionExpatriados(request);
			if(result.data && result.data!=="")
			{
				if(result.data.length===0)
				launchNotification({type:'warning',title:translate('generacion-pdf'),message:`${translate('msg-notificacion-no-datos-documento')}.`})
				else{
					CreateHistoricoPDF(result.data,translate);
				}
				
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			//setIsLoading(false)
		}
	};

    if (params.node.rowPinned) {
        return null;
    }

    return(
        <EuiFlexItem>
			{button}
        </EuiFlexItem>
    )
}